<template>
    <page-loader v-if="loadingStatus == 'loading'" />
    <div v-else class="contain-section">
        <!-- <div class="row">
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <div class="top-banner-box">
                                        <img
                                            src="../../../assets/images/ancetry/banner-3.svg"
                                            alt="Logo"
                                        />
                                    </div>
                                </div>
                            </div> -->
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-7 col-xl-8">
                <div class="inner-box">
                    <div class="banner-box">
                        <img class="rounded-4 h-400 img-row-feedback"
                            :src="overview && overview.main_image ? overview.main_image[0].url : ''" alt="Logo" />
                    </div>
                    <div class="inner-content">
                        <h3 class="mb-3 mt-0 ml-0">{{ overview ? overview.heading : '' }}</h3>
                        <div v-html="overview ? overview.text : ''"></div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-5 col-xl-4">
                <div class="right-bar">
                    <div class="population-group" v-for="card in results" :key="card.key">
                        <h4>{{ card.title }}</h4>

                        <img :src="card?.image" />

                        <div class="row mb-4 classical-row-group">
                            <div class="col-sm-5 p-0 adjust-chart">
                                <DoughnutChart :chart-data="card?.chartData" :options="options" :ChartColor="card?.icon
                                    ? getClassicalColour(card.icon)
                                    : ''
                                    " :centerTitle="card?.score" :centerSubtitle="card.subtitle" chartWidth="100%"
                                    chartHeight="100%" />
                            </div>
                            <div class="col-sm-7" v-if="card.title !== 'Egyptian'">
                                <div class="title" :style="{
                                    color: getClassicalColour(card.icon),
                                }">
                                    {{ card.sampleGroup }}
                                </div>
                                <div class="subtitle">Closest Sample Group</div>
                                <div class="title" :style="{
                                    color: getClassicalColour(card.icon),
                                }">
                                    {{ card.sampleName }}
                                </div>
                                <div class="subtitle">Closest Sample</div>
                            </div>
                            <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5" v-else>
                                <p>
                                    We do not currently provide the closest
                                    sample or sample group for Egyptians due to
                                    limited availability of ancient samples, but
                                    hope to do so in the future.
                                </p>
                            </div>
                        </div>
                        <a :href="'/' + card.overviewRoute" class="load-btn m-auto">{{ card.buttonTxt ? card.buttonTxt : 'Explore Your Result' }}</a>
                    </div>
                    <!-- <div class="population-group">
                                            <h4>Greek</h4>

                                            <img :src="card?.image" />
                                            <div class="row mb-4">
                                                <div
                                                    class="col-sm-6 col-md-6 col-lg-6 col-xl-6"
                                                ></div>
                                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="title">England</div>
                                                    <div class="subtitle">Closest Sample Group</div>
                                                    <div class="title">3DT16</div>
                                                    <div class="subtitle">Closest Sample</div>
                                                </div>
                                            </div>
                                            <a href="#" class="load-btn m-auto"
                                                >Explore Your Result</a
                                            >
                                        </div>
                                        <div class="population-group">
                                            <h4>Egyptian</h4>

                                            <img :src="card?.image" />
                                            <div class="row mb-4">
                                                <div
                                                    class="col-sm-6 col-md-6 col-lg-6 col-xl-6"
                                                ></div>
                                                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                    <div class="title">England</div>
                                                    <div class="subtitle">Closest Sample Group</div>
                                                    <div class="title">3DT16</div>
                                                    <div class="subtitle">Closest Sample</div>
                                                </div>
                                            </div>
                                            <a href="#" class="load-btn m-auto"
                                                >Explore Your Result</a
                                            >
                                        </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import DoughnutChart from "@/components/charts/Doughnut.vue";
import "../../../styles/pages/ancentry/recent-ancetry.scss";
import { getClassicalOverview } from "@/services/classical";
import { ref, onMounted } from "vue";
import {
    getClassicalResult,
    getRequiredContent,
    getClassicalColour,
} from "@/composables/useClassicalContent";
//import Roman from "../../../assets/images/ancetry/roman.svg";
import store from "@/store/index";
const mapCard = ref({});
const introduction = ref({});
let result = ref({});
let results = ref([]);

const loadStatus = ref("loading");
const overview = ref({});

onMounted(async () => {
    overview.value = await getClassicalOverview();
    loadStatus.value = "loaded";
});

Promise.all([
    getRequiredContent(["classical-map-card", "classical-introduction"]),
    getClassicalResult(),
])
    .then(([[mapCardRef, introductionRes], resultRes]) => {
        mapCard.value = mapCardRef;
        introduction.value = introductionRes;
        result.value = resultRes;

        // provide("map-card", mapCard);
        // provide("classical-introduction", introduction);
        // provide("classical-result", result);
        // console.log(store.setCoomit, "store");
        store.commit("setResult", result);
        // Update example chart data with fetched results
        updateChartData();
    })
    .catch((error) => {
        console.error("Error fetching data:", error);
    });

const updateChartData = () => {
    if (!result.value) return;
    console.log("Roman index:", result.value?.romans?.index.toFixed(2));

    exampleRomanChartData.datasets[0].data = [
        result.value?.romans?.index.toFixed(2),
        100 - result.value?.romans?.index.toFixed(2),
    ];

    exampleGreekChartData.datasets[0].data = [
        result.value?.greeks?.index.toFixed(2),
        100 - result.value?.greeks?.index.toFixed(2),
    ];

    exampleEgpytianChartData.datasets[0].data = [
        result.value?.egyptians?.index.toFixed(2),
        100 - result.value?.egyptians?.index.toFixed(2),
    ];
    console.log(exampleRomanChartData, "exampleEgpytianChartData");
    
    results.value = [
        {
            title: overview.value && overview.value.right_section ? overview.value.right_section[0].heading : '', //"Roman",
            subtitle: "",

            score: result.value?.romans?.index.toFixed(2),
            icon: "roman",
            image: overview.value && overview.value.right_section ? overview.value.right_section[0].main_image[0].url : '',
            sampleGroup: result.value?.romans?.closest_sample?.group || "N/A",
            sampleName: result.value?.romans?.closest_sample?.sample || "N/A",
            textColor: "text-red-600",
            titleColor: "text-red-700",
            dividerColor: "bg-red-700",
            borderColor: "border-red-700",
            bgColor: "bg-red-50",
            chartData: exampleRomanChartData,
            resultRoute: "roman-result",
            overviewRoute: "classical/roman",
            buttonTxt: overview.value && overview.value.right_section ? overview.value.right_section[0].button_text : '',
        },
        {
            title: overview.value && overview.value.right_section ? overview.value.right_section[1].heading : '',//"Greek",
            subtitle: "",

            score: result.value?.greeks?.index.toFixed(2),
            icon: "greek",
            image: overview.value && overview.value.right_section ? overview.value.right_section[1].main_image[0].url : '',
            sampleGroup: result.value?.greeks?.closest_sample?.group || "N/A",
            sampleName: result.value?.greeks?.closest_sample?.sample || "N/A",
            textColor: "text-sky-600",
            titleColor: "text-sky-700",
            dividerColor: "bg-sky-700",
            borderColor: "border-sky-700",
            bgColor: "bg-sky-50",
            chartData: exampleGreekChartData,
            resultRoute: "greek-result",
            overviewRoute: "classical/greek",
            buttonTxt: overview.value && overview.value.right_section ? overview.value.right_section[1].button_text : '',
        },
        {
            title: overview.value && overview.value.right_section ? overview.value.right_section[2].heading : '',//"Egyptian",
            subtitle: "",
            score: result.value?.egyptians?.index.toFixed(2),
            icon: "egypt",
            image: overview.value && overview.value.right_section ? overview.value.right_section[2].main_image[0].url : '',
            sampleGroup: result.value?.egyptians?.closest_sample?.group || "N/A",
            sampleName: result.value?.egyptians?.closest_sample?.sample || "N/A",
            textColor: "text-yellow-600",
            titleColor: "text-yellow-700",
            dividerColor: "bg-yellow-700",
            borderColor: "border-yellow-700",
            bgColor: "bg-yellow-50",
            chartData: exampleEgpytianChartData,
            resultRoute: "egyptian-result",
            overviewRoute: "classical/egyptian",
            buttonTxt: overview.value && overview.value.right_section ? overview.value.right_section[2].button_text : '',
        },
    ];
};
const options = {
    cutout: "70%",
    radius: "100%",
    responsive: true,
    maintainAspectRatio: true,
};

const exampleRomanChartData = {
    datasets: [
        {
            data: [0, 100],
            backgroundColor: ["#b91c1c", "#ddd"],
        },
    ],
    labels: [],
};

const exampleGreekChartData = {
    datasets: [
        {
            data: [0, 100],
            backgroundColor: ["#0369a1", "#ddd"],
        },
    ],
    labels: [],
};

const exampleEgpytianChartData = {
    datasets: [
        {
            data: [0, 100],
            backgroundColor: ["#a16207", "#ddd"],
        },
    ],
    labels: [],
};
</script>
